export class TrendPoint {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "date",
            "baseName": "date",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalResources",
            "baseName": "totalResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "compliantResources",
            "baseName": "compliantResources",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return TrendPoint.attributeTypeMap;
    }
    constructor() {
    }
}
